export const RANGE_PRICES = {
  arkitektPlus: [60720, 127560, 127920],
  signaturEkbacken: [120000, 228000, 240000],
  fagero: [67440, 141480, 133920],
  form: [60720, 127560, 123120],
  lindo: [67440, 141480, 134040],
  viken: [64200, 131760, 131520],
  ramsvik: [64560, 132840, 131880],
  malevik: [53520, 109200, 107280],
}

export const WORKTOP_PRICES = {
  laminate: [17160, 22200, 26640],
  solidTimber: [32520, 48600, 56040],
  granite: [52440, 116160, 91440],
  stainless: [42996, 56880, 75120],
}
